import cn from '@/utils/cn'
import type { ComponentPropsWithoutRef } from 'react'

const Container = ({ children, className }: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('w-full', className)}>{children}</div>
}

export default Container
